<template>
	<button
		class="button-loading"
		:disabled="props.disabled || props.isLoading"
		@click="e => emit('click', e)"
	>
		<img
			v-if="props.useSaturnIcon && props.isLoading"
			src="@static/img/SaturnLogoAnim.svg"
		/>
		<i
			v-else-if="props.isLoading"
			:class="['fas fa-spin', props.loadingIcon ? props.loadingIcon : 'fa-circle-notch']"
		/>

		<span
			v-if="props.isLoading && !props.iconOnly"
			style="margin-left: 1ch"
		>
			{{ props.loadingText }}
		</span>
		<slot v-else-if="!props.isLoading"></slot>
	</button>
</template>

<script setup lang="ts">
	export interface IButtonLoadingProps {
		/** When true, button is disabled and content is replaced with the loading message */
		isLoading: boolean;

		/** When true, disables the button */
		disabled?: boolean;

		/** Font Awesome icon class. If not provided, defaults to `fa-circle-notch` */
		loadingIcon?: string;

		/** When true, replaces the loading spinner with a spinning Saturn icon. */
		useSaturnIcon?: boolean;

		/** When loading, only displays the loading indicator without any loading text. */
		iconOnly?: boolean;

		/** Text to display in the button while it's loading. */
		loadingText?: string;
	}

	const props = withDefaults(defineProps<IButtonLoadingProps>(), {
		loadingText: 'Loading...',
	});
	const emit = defineEmits(['click']);
</script>
<style>
	button.button-loading {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	button.button-loading img {
		height: 70%;
		-webkit-filter: invert(100%);
		filter: invert(100%);
	}
</style>
